import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var getApplicantFullName = function (applicant) {
    return applicant ? "".concat(applicant.firstName, " ").concat(applicant.lastName) : '';
};
export var getUniqueApplicantLabel = function (applicant, index, applicants) {
    var fullName = getApplicantFullName(applicant);
    var hasCollision = applicants.filter(function (a) { return getApplicantFullName(a) === fullName; }).length > 1;
    return hasCollision ? "".concat(fullName, " (").concat(applicant.email || index + 1, ")") : fullName;
};
export var getSmsValueLabel = function (hasPhone, cell, i18n) {
    if (!hasPhone || !cell) {
        return getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.smsLabelDisabled') || '';
    }
    var template = getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.smsPhone') || '$phone';
    return template.replace('$phone', cell);
};
export var getEmailValueLabel = function (hasEmail, email, i18n) {
    if (!hasEmail || !email) {
        return getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.emailLabelDisabled') || '';
    }
    var template = getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.emailAdress') || '$email';
    return template.replace('$email', email);
};
